<!-- <div style=" margin-top: 6.5%;display: flex;width: 100%;">
    <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar></app-jsip-product-info-bar> -->
<div class="main-container">
<div class="label-bar">

  <label
    i18n="@@spmsUserReg"
    class="textColour headerLabel-20">
    Review And Approve
  </label>
   <span class="example-spacer"></span>

  <!-- <app-jsignal-nav-links></app-jsignal-nav-links> -->

</div>


  <!-- GRID MODE -->
  <div *ngIf="!isPreview" style="padding: 5px 10px;margin-top: 2%;">
      <!-- Toolbar -->
      <div [style.background-color]="backgroundColorScreen" >
        <mat-toolbar class="agGridtoperDiv card" 
                     style="background: rgb(244 243 245); border: 1px solid #a9a9a9a8; border-top: none;margin-top: 0;">
            <button mat-icon-button 
          class="header-config-btn"
          (click)="$event.stopPropagation(); openColumnsDialog()"
          matTooltip="Select columns to display">
    <mat-icon>tune</mat-icon>
    </button>
                     <span class="example-spacer"></span>

          <!-- Action Buttons
          <button *ngIf="selectedRows.length > 0"
                  class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="backgroundColorButton"
                  title="Request Changes"
                  (click)="RequestChanges()">
            Request Changes
          </button>

          <button *ngIf="selectedRows.length > 0"
                  class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="backgroundColorButton"
                  title="Approve"
                  (click)="onComplete()">
            Approve
          </button> -->

          <!-- <button class="slim-button btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="backgroundColorButton"
                  [disabled]="isDownloading"
                  title="Download"
                  (click)="onDownloadhistory()">
           <span class="btn-content">
            <span>Download</span>
            <em class="fas fa-download"></em>
            </span>
          </button> -->

          		     <app-common-button
 
          label="Download"
 
          title="Download "
 
          icon="fas fa-download"
 
          [buttonId]="1111"

          [critical]="false"
          (clicked)="onDownloadhistory()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

          <!-- <button class="slim-button popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="backgroundColorButton"
                  title="Refresh"
                  (click)="onrefresh()">
             <span class="btn-content">
                            <span>Refresh</span>
                            <em class="fas fa-sync-alt"></em>
                          </span>
          </button> -->

          <app-common-button
 
          label="Refresh"
 
          title="Refresh "
 
          icon="fas fa-sync-alt"
 
          [buttonId]="1111"
 
         
          [critical]="false"
          (clicked)="onrefresh()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

          <!-- Pagination Controls -->
          <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Targetpageno">Page No</mat-label>
              <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
            </mat-form-field>
          </div>

          <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
              <mat-select [(ngModel)]="RunpageSize" [ngModelOptions]="{standalone:true}" (ngModelChange)="onRunPageSizeChanged($event)">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left" (click)="onRunBtFirst()"></em>
          </div>
          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em class="fas fa-angle-left" (click)="onRunBtPrevious()"></em>
              </li>
              <li>{{RuncurrentPage}}/{{RuntotalPages}}</li>
              <li class="paginationliicon" style="padding:0;">
                <em class="fas fa-angle-right" (click)="onRunBtNext()"></em>
              </li>
            </ul>
          </div>
          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right" (click)="onRunBtLast()"></em>
          </div>
        </mat-toolbar>

        <!-- AG Grid -->
        <ag-grid-angular
          [style.height]="isPreview ? '75vh' : '50vh'"
          id="Grid"
          class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefs"
          [rowData]="gridRowData"
          [defaultColDef]="defaultColDef"
          [rowMultiSelectWithClick]="true"
          [animateRows]="true"
          [pagination]="true"
          [suppressPaginationPanel]="true"
          [rowHeight]="35"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [components]="components"
          [rowClassRules]="rowClassRules"
          [getRowStyle]="getRowStyle"
          (paginationChanged)="onPaginationChanged()"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
  </div>

  
<!-- REVIEW MODE - Fixed Height Container -->
  <div *ngIf="isPreview" class="review-mode-container">
    <div class="edit-mode-wrapper">
      <div class="left-pane" *ngIf="ProductStrategyJson">
        <app-stepper-form 
          [jsonData]="ProductStrategyJson" 
          [role]="userRole"
          (cancel)="onReviewCancel($event)"
          (sectionId)="onSectionChange($event)"
          [commentCountMap]="commentCountMap"
          [StrategyId]="selectedStrategyId"
          [pssState]="PSSstate"
          [pssID]="id"
          [totalOpenComments]="totalOpenComments">
        </app-stepper-form>
      </div>

      <!-- Fixed comments -->
      <div class="right-pane">
        <app-comments 
          [strategyId]="selectedStrategyId"
          [commentsData]="allCommentsJson"
          [isFirstLoad]="isFirstLoad"
          (cancel)="cancelPreview($event)"
          (action)="handleReviewerAction($event)"
          [sectionId]="currentSectionId"
          [role]="userRole"
          (commentCounts)="onCommentCountsUpdated($event)"
          (totalOpenComments)="onTotalOpenComments($event)">
        </app-comments>
      </div>
    </div>
  </div>
</div>
<!-- </div>
</div> -->
